import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { clearStorageData } from '../../../utils/storage/storage';
import { toastSuccess } from '../../../utils/toast';

export const useAboutSettings = () => {
  const { t } = useTranslation('profile');
  const [showAppDataClearDialogConfirmation, setShowAppDataClearDialogConfirmation] = useState<boolean>(false);

  const handleClearAppData = () => {
    clearStorageData();
    toastSuccess({ content: t('clear-app-data.toast') });
    setShowAppDataClearDialogConfirmation(false);
  };

  return {
    handleClearAppData,
    showAppDataClearDialogConfirmation,
    setShowAppDataClearDialogConfirmation,
  };
};
